(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const root = document.documentElement;
  const hero = document.getElementById('shopify-section-301eb600-c0b1-45a7-a7e0-324a5a6c426b');
  const sectionIds = [
    'shopify-section-5f88f0aa-a30c-49d9-b366-2cab3627844a',
    'shopify-section-4af6de98-dad3-4fed-8c80-e9e9ed79735c',
    'shopify-section-fb736651-6591-4114-9f9d-8b62a76f5c38',
    'shopify-section-d5dcc211-0046-4752-9ca6-57ad01e5db73'
  ];
  const sections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);

  if (!hero && !sections.length) return;
  root.classList.add('toak-motion-ready');

  sections.forEach((section) => {
    section.classList.add('toak-reveal');
    if (section.querySelector('.product-card')) {
      section.classList.add('featured-motion-products');
      section.querySelectorAll('.product-card').forEach((card, index) => {
        card.style.setProperty('--toak-delay', `${Math.min(index, 5) * 90}ms`);
      });
    }
  });

  if ('IntersectionObserver' in window) {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { rootMargin: '-7% 0px -7% 0px', threshold: 0.08 });
    sections.forEach((section) => sectionObserver.observe(section));

    if (hero) {
      window.setTimeout(() => {
        const heroObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            root.classList.toggle('toak-motion-start', entry.isIntersecting);
          });
        }, { rootMargin: '-10% 0px -10% 0px', threshold: 0.08 });
        heroObserver.observe(hero);
      }, 680);
    }
  } else {
    root.classList.add('toak-motion-start');
    sections.forEach((section) => section.classList.add('is-visible'));
  }

  let ticking = false;
  const updateHeroDepth = () => {
    if (!hero) return;
    const shift = Math.min(window.scrollY * 0.04, 30);
    hero.style.setProperty('--toak-hero-shift', `${shift}px`);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeroDepth);
  }, { passive: true });

  window.setTimeout(() => {
    if (hero) {
      const rect = hero.getBoundingClientRect();
      root.classList.toggle('toak-motion-start', rect.bottom > 0 && rect.top < window.innerHeight);
    }
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      section.classList.toggle('is-visible', rect.bottom > 0 && rect.top < window.innerHeight);
    });
  }, 3600);
})();
